var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "app" } }, [
    _c(
      "div",
      {
        staticClass:
          "tw-bg-common-text-alert tw-mb-[64px] tw-flex tw-flex-col tw-gap-[10px]"
      },
      [
        _c("h1", { staticClass: "tw-text-center" }, [
          _vm._v("SELLSY UI LIBRARY")
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "container tw-flex-col",
            staticStyle: { "margin-top": "100px" }
          },
          [
            _c(
              "div",
              { staticClass: "tw-align-self-start typographies-heading-h1" },
              [
                _vm._v(
                  "\n                RichText: (Not a Compass component)\n            "
                )
              ]
            ),
            _vm._v(" "),
            _c("RichText", {
              staticClass: "custom-richtext",
              attrs: {
                formitem: _vm.formItemRichText,
                placeholder: _vm.$t.__("pages.Compass2.enter_text"),
                options: _vm.optionsRichText
              },
              scopedSlots: _vm._u([
                {
                  key: "more-custom-options",
                  fn: function() {
                    return [
                      _c("CompassIconButton", {
                        attrs: { icon: "performance", size: "small" },
                        on: {
                          click: function($event) {
                            return _vm.handleLog("Custom button clicked")
                          }
                        }
                      })
                    ]
                  },
                  proxy: true
                },
                {
                  key: "actions",
                  fn: function() {
                    return [
                      _c(
                        "div",
                        { staticClass: "tw-flex tw-gap-2" },
                        [
                          _c("CompassButton", {
                            attrs: {
                              label: "Annuler",
                              type: "secondary",
                              size: "small"
                            },
                            on: {
                              click: function($event) {
                                return _vm.handleLog("Annuler clicked")
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("CompassButton", {
                            attrs: {
                              label: "Confirmer",
                              type: "primary",
                              size: "small"
                            },
                            on: {
                              click: function($event) {
                                return _vm.handleLog("Confirmer clicked")
                              }
                            }
                          })
                        ],
                        1
                      )
                    ]
                  },
                  proxy: true
                }
              ]),
              model: {
                value: _vm.editorContent,
                callback: function($$v) {
                  _vm.editorContent = $$v
                },
                expression: "editorContent"
              }
            }),
            _vm._v(" "),
            _c("RichText", {
              staticClass: "custom-richtext",
              attrs: {
                formitem: _vm.formItemRichText,
                placeholder: _vm.$t.__("pages.Compass2.enter_text"),
                options: _vm.optionsRichText,
                disabled: true
              },
              model: {
                value: _vm.editorContent,
                callback: function($$v) {
                  _vm.editorContent = $$v
                },
                expression: "editorContent"
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "tw-align-self-start typographies-heading-h1" },
          [_vm._v("CompassAlert :")]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "container tw-flex-col" },
          [
            _c("CompassAlert", {
              attrs: {
                type: "warning",
                description: _vm.neil,
                "show-close": false,
                "show-icon": false,
                action: {
                  label: "clickme",
                  callback: function() {
                    return _vm.handleClick()
                  }
                }
              }
            }),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _c("CompassAlert", {
              attrs: {
                type: "informative",
                description: "Alert informative + close",
                "show-close": true,
                "show-icon": false,
                action: {
                  label: "clickme",
                  callback: function() {
                    return _vm.handleClick()
                  }
                }
              }
            }),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _c("CompassAlert", {
              attrs: {
                type: "error",
                description: "Alert error + icon",
                "show-close": false,
                "show-icon": true,
                action: {
                  label: "clickme",
                  callback: function() {
                    return _vm.handleClick()
                  }
                }
              }
            }),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _c("CompassAlert", {
              attrs: {
                type: "success",
                description: "Alert success + close + icon",
                "show-close": true,
                "show-icon": true,
                action: {
                  label: "clickme",
                  callback: function() {
                    return _vm.handleClick()
                  }
                }
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "tw-align-self-start typographies-heading-h1" },
          [_vm._v("CompassAutoComplete :")]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "container" },
          [
            _c("CompassAutoComplete", {
              attrs: {
                placeholder: "Rechercher",
                size: "medium",
                "no-results-label": "Aucun résultat",
                results: _vm.results,
                "has-more-results": _vm.hasMoreResults,
                loading: _vm.loading,
                "dropdown-footer": [
                  { label: "Footer action", callback: function() {} }
                ],
                error: false,
                disabled: false
              },
              on: {
                "update-search": _vm.handleAutoCompleteFetchResults,
                "load-more-results": _vm.handleAutoCompleteFetchMoreResults,
                change: _vm.handleAutoCompleteChange
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "tw-align-self-start typographies-heading-h1" },
          [_vm._v("CompassAvatar :")]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "container" },
          [
            _c("CompassAvatar", {
              attrs: {
                photo:
                  "https://i-mom.unimedias.fr/2022/03/14/chat.jpg?auto=format%2Ccompress&crop=faces&cs=tinysrgb&fit=crop&h=591&w=1050",
                initials: "xx",
                size: "extra-large"
              }
            }),
            _vm._v(" "),
            _c("CompassAvatar", {
              attrs: { initials: "xx", size: "large", border: true }
            }),
            _vm._v(" "),
            _c("CompassAvatar", {
              attrs: {
                initials: "xx",
                size: "medium",
                "color-type": "bg-component-background-avatar-random-pink",
                "state-badge": "removed"
              }
            }),
            _vm._v(" "),
            _c("CompassAvatar", {
              attrs: {
                initials: "xx",
                size: "small",
                "color-type": "bg-component-background-avatar-random-yellow",
                "state-badge": "deactivated"
              }
            }),
            _vm._v(" "),
            _c("CompassAvatar", {
              attrs: {
                initials: "xx",
                size: "extra-small",
                "color-type": "bg-component-background-avatar-random-green",
                "avatar-type": "disabled"
              }
            }),
            _vm._v(" "),
            _c("CompassAvatar", {
              attrs: { size: "extra-small", type: "team" }
            }),
            _vm._v(" "),
            _c("CompassAvatar", { attrs: { size: "large", type: "company" } })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "tw-align-self-start typographies-heading-h1" },
          [_vm._v("CompassAvatarName :")]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "container" },
          [
            _c(
              "CompassAvatarName",
              {
                attrs: {
                  firstname: "Dave",
                  lastname: "Chapelle",
                  caption: "Comedian",
                  size: "extra-large"
                }
              },
              [
                _c("CompassAvatar", {
                  attrs: {
                    initials: "DC",
                    photo:
                      "https://i-mom.unimedias.fr/2022/03/14/chat.jpg?auto=format%2Ccompress&crop=faces&cs=tinysrgb&fit=crop&h=591&w=1050"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "CompassAvatarName",
              {
                attrs: {
                  firstname: "Dave",
                  lastname: "Chapelle",
                  caption: "Comedian",
                  size: "large"
                }
              },
              [_c("CompassAvatar", { attrs: { initials: "DC" } })],
              1
            ),
            _vm._v(" "),
            _c(
              "CompassAvatarName",
              {
                attrs: {
                  firstname: "Dave",
                  lastname: "Chapelle",
                  caption: "Comedian",
                  "show-caption": false
                }
              },
              [
                _c("CompassAvatar", {
                  attrs: {
                    initials: "DC",
                    "avatar-color-type":
                      "bg-component-background-avatar-random-yellow"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "CompassAvatarName",
              {
                attrs: {
                  firstname: "Dave",
                  lastname: "Chapelle",
                  caption: "Comedian",
                  size: "small"
                }
              },
              [
                _c("CompassAvatar", {
                  attrs: {
                    initials: "DC",
                    "avatar-color-type":
                      "bg-component-background-avatar-random-pink",
                    "state-badge": "deactivated"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "CompassAvatarName",
              {
                attrs: {
                  firstname: "Dave",
                  lastname: "Chapelle",
                  caption: "Comedian",
                  size: "extra-small",
                  "show-caption": false
                }
              },
              [
                _c("CompassAvatar", {
                  attrs: { initials: "DC", "state-badge": "removed" }
                })
              ],
              1
            )
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "container tw-flex-col" }, [
          _c("p", [_vm._v("Resize window to see ellipsis :")]),
          _vm._v(" "),
          _c(
            "div",
            { staticStyle: { width: "20%" } },
            [
              _c(
                "CompassAvatarName",
                {
                  attrs: {
                    size: "extra-large",
                    firstname: "Dave",
                    lastname: "Chapelle",
                    caption: "Comedian"
                  }
                },
                [
                  _c("CompassAvatar", {
                    attrs: { initials: "DC", "state-badge": "removed" }
                  })
                ],
                1
              )
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "tw-align-self-start typographies-heading-h1" },
          [_vm._v("\n            CompassBackForwardButton :\n        ")]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "container" },
          [
            _c("CompassBackForwardButton", {
              attrs: {
                link: "https:go.sellsy.com",
                forward: "",
                label: "Placeholder",
                size: "small",
                type: "primary"
              },
              on: { click: _vm.handleClick }
            }),
            _vm._v(" "),
            _c("CompassBackForwardButton", {
              attrs: {
                link: "https:go.sellsy.com",
                forward: "",
                label: "Placeholder",
                size: "medium",
                type: "secondary"
              },
              on: { click: _vm.handleClick }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "container" },
          [
            _c("CompassBackForwardButton", {
              attrs: {
                link: "https:go.sellsy.com",
                forward: "",
                label: "Placeholder",
                size: "small",
                type: "primary",
                disabled: ""
              },
              on: { click: _vm.handleClick }
            }),
            _vm._v(" "),
            _c("CompassBackForwardButton", {
              attrs: {
                link: "https:go.sellsy.com",
                forward: "",
                label: "Placeholder",
                size: "medium",
                type: "secondary",
                disabled: ""
              },
              on: { click: _vm.handleClick }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "tw-align-self-start typographies-heading-h1" },
          [_vm._v("CompassBadge :")]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "container" },
          [
            _c("CompassBadge", {
              attrs: { type: "client", size: "large" },
              on: { click: _vm.handleClick }
            }),
            _vm._v(" "),
            _c("CompassBadge", { attrs: { type: "prospect", size: "medium" } }),
            _vm._v(" "),
            _c(
              "CompassBadge",
              {
                attrs: {
                  type: "custom",
                  "bg-color": "sellsy-brand-primary-100",
                  size: "small"
                }
              },
              [_vm._v("Custom Badge")]
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "tw-align-self-start typographies-heading-h1" },
          [_vm._v("CompassBanner :")]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "container" },
          [
            _c("CompassBanner", {
              attrs: {
                description:
                  "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Libero ducimus ea similique expedita beatae tenetur quae minima tempora eligendi esse!",
                type: "informative",
                action: {
                  label: "clickme",
                  callback: function() {
                    return _vm.handleClick()
                  }
                }
              }
            }),
            _vm._v(" "),
            _c("CompassBanner", {
              attrs: {
                description: "Bonjour, je suis une bannière",
                type: "error",
                offset: { x: 64, y: 101 }
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "tw-align-self-start typographies-heading-h1" },
          [_vm._v("CompassButton :")]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "typographies-paragraph-medium-regular" }, [
          _vm._v("Primary :")
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "container" },
          [
            _c("CompassButton", {
              attrs: { label: "Placeholder", type: "primary", size: "small" },
              on: {
                click: function($event) {
                  return _vm.handleLog("clicked")
                }
              }
            }),
            _vm._v(" "),
            _c("CompassButton", {
              attrs: {
                label: "Placeholder",
                type: "primary-destructive",
                size: "medium"
              },
              on: {
                click: function($event) {
                  return _vm.handleLog("clicked")
                }
              }
            }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "tw-bg-sellsy-brand-primary-100 tw-p-[5px]" },
              [
                _c("CompassButton", {
                  attrs: {
                    label: "Placeholder",
                    type: "primary-contrast",
                    size: "large"
                  },
                  on: {
                    click: function($event) {
                      return _vm.handleLog("clicked")
                    }
                  }
                })
              ],
              1
            )
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "typographies-paragraph-medium-regular" }, [
          _vm._v("Secondary :")
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "container" },
          [
            _c("CompassButton", {
              attrs: { label: "Placeholder", type: "secondary", size: "small" },
              on: {
                click: function($event) {
                  return _vm.handleLog("clicked")
                }
              }
            }),
            _vm._v(" "),
            _c("CompassButton", {
              attrs: {
                label: "Placeholder",
                type: "secondary-destructive",
                size: "medium"
              },
              on: {
                click: function($event) {
                  return _vm.handleLog("clicked")
                }
              }
            }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "tw-bg-sellsy-brand-primary-100 tw-p-[5px]" },
              [
                _c("CompassButton", {
                  attrs: {
                    label: "Placeholder",
                    type: "secondary-contrast",
                    size: "large"
                  },
                  on: {
                    click: function($event) {
                      return _vm.handleLog("clicked")
                    }
                  }
                })
              ],
              1
            )
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "typographies-paragraph-medium-regular" }, [
          _vm._v("Tertiary :")
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "container" },
          [
            _c("CompassButton", {
              attrs: { label: "Placeholder", type: "tertiary", size: "small" },
              on: {
                click: function($event) {
                  return _vm.handleLog("clicked")
                }
              }
            }),
            _vm._v(" "),
            _c("CompassButton", {
              attrs: {
                label: "Placeholder",
                type: "tertiary-destructive",
                size: "medium"
              },
              on: {
                click: function($event) {
                  return _vm.handleLog("clicked")
                }
              }
            }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "tw-bg-sellsy-brand-primary-100 tw-p-[5px]" },
              [
                _c("CompassButton", {
                  attrs: {
                    label: "Placeholder",
                    type: "tertiary-contrast",
                    size: "large"
                  },
                  on: {
                    click: function($event) {
                      return _vm.handleLog("clicked")
                    }
                  }
                })
              ],
              1
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "tw-align-self-start typographies-heading-h1" },
          [_vm._v("CompassCheckbox :")]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "container tw-flex-col" }, [
          _c(
            "div",
            { staticClass: "tw-flex tw-flex-col tw-items-start tw-gap-2" },
            [
              _c("CompassCheckbox", {
                attrs: { "model-value": "modelChecked1" }
              }),
              _vm._v(" "),
              _c("CompassCheckbox", {
                attrs: { "model-value": "modelChecked2 checked", checked: "" }
              }),
              _vm._v(" "),
              _c("CompassCheckbox", {
                attrs: {
                  "model-value": "modelChecked3 small indeterminate",
                  size: "small",
                  indeterminate: ""
                }
              }),
              _vm._v(" "),
              _c("CompassCheckbox", {
                attrs: {
                  "model-value": "modelChecked4 large disabled",
                  size: "large",
                  disabled: ""
                }
              }),
              _vm._v(" "),
              _c("CompassCheckbox", {
                attrs: { "model-value": "modelChecked5 error", error: "" }
              }),
              _vm._v(" "),
              _c("p", [_vm._v("No label checkbox")]),
              _vm._v(" "),
              _c("CompassCheckbox", {
                attrs: {
                  "model-value": "modelChecked5 checked",
                  size: "small",
                  checked: "",
                  error: "",
                  "show-label": false
                }
              }),
              _vm._v(" "),
              _c("CompassCheckbox", {
                attrs: {
                  "model-value": "modelChecked5 checked",
                  checked: "",
                  error: "",
                  "show-label": false
                }
              }),
              _vm._v(" "),
              _c("CompassCheckbox", {
                attrs: {
                  "model-value": "modelChecked5 checked",
                  size: "large",
                  checked: "",
                  error: "",
                  "show-label": false
                }
              })
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "tw-align-self-start typographies-heading-h1" },
          [_vm._v("CompassCheckboxGroup :")]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "container tw-flex-col" }, [
          _c(
            "div",
            { staticClass: "tw-flex tw-flex-col tw-items-start tw-gap-4" },
            [
              _c(
                "CompassCheckboxGroup",
                {
                  attrs: {
                    label: "CheckboxGroup horizontal medium",
                    direction: "horizontal",
                    size: "medium"
                  },
                  model: {
                    value: _vm.checkboxGroupModel,
                    callback: function($$v) {
                      _vm.checkboxGroupModel = $$v
                    },
                    expression: "checkboxGroupModel"
                  }
                },
                [
                  _c("CompassCheckbox", {
                    attrs: { "model-value": "small", size: "small" }
                  }),
                  _vm._v(" "),
                  _c("CompassCheckbox", {
                    attrs: { "model-value": "medium", size: "medium" }
                  }),
                  _vm._v(" "),
                  _c("CompassCheckbox", {
                    attrs: { "model-value": "large", size: "large" }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "CompassCheckboxGroup",
                {
                  attrs: {
                    label: "CheckboxGroup vertical small",
                    direction: "vertical",
                    size: "small"
                  },
                  model: {
                    value: _vm.checkboxGroupModel2,
                    callback: function($$v) {
                      _vm.checkboxGroupModel2 = $$v
                    },
                    expression: "checkboxGroupModel2"
                  }
                },
                [
                  _c("CompassCheckbox", {
                    attrs: {
                      "model-value": "MyValue",
                      size: "small",
                      indeterminate: ""
                    }
                  }),
                  _vm._v(" "),
                  _c("CompassCheckbox", {
                    attrs: {
                      "model-value": "MyValue2",
                      size: "medium",
                      disabled: ""
                    }
                  }),
                  _vm._v(" "),
                  _c("CompassCheckbox", {
                    attrs: {
                      "model-value": "MyValue3",
                      size: "large",
                      error: ""
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "CompassCheckboxGroup",
                {
                  attrs: {
                    label: "CheckboxGroup horizontal large",
                    direction: "horizontal",
                    size: "large"
                  }
                },
                [
                  _c("CompassCheckbox", {
                    attrs: {
                      "model-value": "MyValue small checked",
                      size: "small",
                      checked: ""
                    }
                  }),
                  _vm._v(" "),
                  _c("CompassCheckbox", {
                    attrs: {
                      "model-value": "MyValue2 medium checked",
                      size: "medium",
                      checked: ""
                    }
                  }),
                  _vm._v(" "),
                  _c("CompassCheckbox", {
                    attrs: {
                      "model-value": "MyValue3 large checked",
                      size: "large",
                      checked: ""
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "tw-align-self-start typographies-heading-h1" },
          [_vm._v("CompassDialog :")]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "container" },
          [
            _c(
              "CompassButton",
              {
                attrs: { label: "Dialog 1" },
                on: {
                  click: function($event) {
                    _vm.openModalOne = true
                  }
                }
              },
              [_vm._v("Open Dialog 1 (overflowed text + bodyScroll allowed)")]
            ),
            _vm._v(" "),
            _c(
              "CompassButton",
              {
                attrs: { label: "Dialog 2" },
                on: {
                  click: function($event) {
                    _vm.openModalTwo = true
                  }
                }
              },
              [
                _vm._v(
                  "Open Dialog 2 (bodyScroll not allowed + custom cancel handler)"
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "CompassButton",
              {
                attrs: { label: "Dialog 3" },
                on: {
                  click: function($event) {
                    _vm.openModalThree = true
                  }
                }
              },
              [
                _vm._v(
                  "Open Dialog 3 (bodyScroll not allowed + can not close on click on\n                overlay)"
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "CompassDialog",
              {
                attrs: {
                  visible: _vm.openModalOne,
                  title:
                    "LongWordLongWordLongWordLongWordLongWordLongWordLongWordLongWordLongWordLongWordLongWordLongWordLongWordLongWordLongWordLongWordLongWordLongWordLongWordLongWordLongWordLongWordLongWordLongWord Titre de la modal One",
                  "primary-action": {
                    label: "primaryAction",
                    action: function() {
                      return _vm.handleLog("primaryAction clicked")
                    }
                  },
                  "secondary-actions": [
                    {
                      label: "secondaryAction1",
                      action: function() {
                        return _vm.handleLog("secondaryAction1 clicked")
                      }
                    },
                    {
                      label: "secondaryAction2",
                      action: function() {
                        return _vm.handleLog("secondaryAction2 clicked")
                      }
                    }
                  ],
                  "body-scroll": ""
                },
                on: {
                  "update:visible": function($event) {
                    _vm.openModalOne = $event
                  },
                  opened: function($event) {
                    return _vm.handleLog("opened")
                  },
                  closed: function($event) {
                    return _vm.handleLog("closed")
                  }
                }
              },
              _vm._l(70, function(_, index) {
                return _c(
                  "p",
                  {
                    key: "modal-content-" + index,
                    staticStyle: { margin: "0px" }
                  },
                  [
                    _vm._v(
                      "\n                    Modal Content\n                "
                    )
                  ]
                )
              }),
              0
            ),
            _vm._v(" "),
            _c(
              "CompassDialog",
              {
                attrs: { visible: _vm.openModalTwo },
                on: {
                  "update:visible": function($event) {
                    _vm.openModalTwo = $event
                  }
                }
              },
              [
                _c("template", { slot: "header" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "tw-flex tw-items-center tw-justify-center tw-p-[10px]"
                    },
                    [
                      _c("div", { staticClass: "typographies-heading-h2" }, [
                        _vm._v("Custom Header")
                      ])
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "\n                    Lorem ipsum dolor sit amet consectetur adipisicing elit. Soluta quisquam\n                    provident voluptate consequuntur similique praesentium ex beatae est nisi\n                    earum?\n                "
                  )
                ]),
                _vm._v(" "),
                _c("template", { slot: "footer" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "tw-flex tw-items-center tw-justify-center tw-gap-[5px] tw-p-[10px]"
                    },
                    [
                      _c("CompassButton", {
                        attrs: { label: "Annuler" },
                        on: {
                          click: function($event) {
                            return _vm.handleLog("Annuler clicked")
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("CompassButton", {
                        attrs: { label: "Confirmer" },
                        on: {
                          click: function($event) {
                            return _vm.handleLog("Confirmer clicked")
                          }
                        }
                      })
                    ],
                    1
                  )
                ])
              ],
              2
            ),
            _vm._v(" "),
            _c("CompassDialog", {
              attrs: {
                visible: _vm.openModalThree,
                "close-on-click-overlay": false,
                title: "Titre de la modal Three",
                "primary-action": {
                  label: "primaryAction",
                  action: function() {
                    return _vm.handleLog("primaryAction clicked")
                  }
                },
                "secondary-actions": [
                  {
                    label: "secondaryAction1",
                    action: function() {
                      return _vm.handleLog("secondaryAction1 clicked")
                    }
                  },
                  {
                    label: "secondaryAction2",
                    action: function() {
                      return _vm.handleLog("secondaryAction2 clicked")
                    }
                  }
                ]
              },
              on: {
                "update:visible": function($event) {
                  _vm.openModalThree = $event
                },
                opened: function($event) {
                  return _vm.handleLog("opened")
                },
                closed: function($event) {
                  return _vm.handleLog("closed")
                }
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "tw-align-self-start typographies-heading-h1" },
          [_vm._v("CompassFeatureBadge :")]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "container" },
          [
            _c("CompassFeatureBadge"),
            _vm._v(" "),
            _c("CompassFeatureBadge", { attrs: { size: "small" } }),
            _vm._v(" "),
            _c("CompassFeatureBadge", { attrs: { variant: "upsell" } }),
            _vm._v(" "),
            _c("CompassFeatureBadge", {
              attrs: { size: "small", variant: "upsell" }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "tw-align-self-start typographies-heading-h1" },
          [_vm._v("CompassFeatureModal :")]
        ),
        _vm._v(" "),
        _c("CompassButton", {
          attrs: { label: "Open Feature Modal" },
          on: {
            click: function($event) {
              _vm.openFeatureModal = true
            }
          }
        }),
        _vm._v(" "),
        _c(
          "CompassFeatureModal",
          {
            attrs: {
              visible: _vm.openFeatureModal,
              title: "Titre de la modal Three",
              "primary-action": {
                label: "primaryAction",
                action: function() {
                  return _vm.handleLog("primaryAction clicked")
                }
              }
            },
            on: {
              "update:visible": function($event) {
                _vm.openFeatureModal = $event
              },
              opened: function($event) {
                return _vm.handleLog("opened")
              },
              closed: function($event) {
                return _vm.handleLog("closed")
              }
            }
          },
          [
            _c("template", { slot: "header" }, [
              _c("img", {
                attrs: {
                  src:
                    "/ressources/logged/img/illustrations/modal-services-upgrade-plan.svg"
                }
              })
            ]),
            _vm._v(" "),
            [_vm._v("Content here ? ")]
          ],
          2
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "tw-align-self-start typographies-heading-h1" },
          [_vm._v("CompassFlag :")]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "container tw-flex-col" },
          [
            _c("CompassFlag", { attrs: { label: "New", size: "small" } }),
            _vm._v(" "),
            _c("CompassFlag", { attrs: { label: "New" } }),
            _vm._v(" "),
            _c("CompassFlag", { attrs: { label: "New", size: "large" } }),
            _vm._v(" "),
            _c("CompassFlag", {
              attrs: { label: "Beta", beta: true, size: "small" }
            }),
            _vm._v(" "),
            _c("CompassFlag", { attrs: { label: "Beta", beta: true } }),
            _vm._v(" "),
            _c("CompassFlag", {
              attrs: { label: "Beta", beta: true, size: "large" }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "tw-align-self-start typographies-heading-h1" },
          [_vm._v("CompassFormItem :")]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "container tw-flex-col" },
          [
            _c(
              "CompassFormItem",
              {
                attrs: {
                  label: "Label",
                  info: "Long caption text for input",
                  error: "Long warn text for input",
                  size: "small",
                  disabled: _vm.isDisabled,
                  required: ""
                }
              },
              [
                _c("CompassInput", {
                  attrs: {
                    size: "small",
                    "suffix-icon": "heart",
                    placeholder: "Placeholder",
                    error: _vm.hasError,
                    disabled: _vm.isDisabled
                  },
                  on: {
                    keypress: function($event) {
                      return _vm.handleLog("keypress")
                    },
                    input: function($event) {
                      return _vm.handleLog("input")
                    }
                  },
                  model: {
                    value: _vm.inputModel3,
                    callback: function($$v) {
                      _vm.inputModel3 = $$v
                    },
                    expression: "inputModel3"
                  }
                })
              ],
              1
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "tw-align-self-start typographies-heading-h1" },
          [_vm._v("CompassIcon :")]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "container" },
          [
            _c("CompassIcon", {
              attrs: { icon: "dashboard-fill", size: "large" }
            }),
            _vm._v(" "),
            _c("CompassIcon", {
              attrs: { icon: "heart", size: "large", type: "secondary" }
            }),
            _vm._v(" "),
            _c("CompassIcon", {
              attrs: { icon: "accounting-fill", size: "large", type: "alert" }
            }),
            _vm._v(" "),
            _c("CompassIcon", {
              attrs: { icon: "richeditor-text-height", size: "large" }
            }),
            _vm._v(" "),
            _c("CompassIcon", {
              attrs: { icon: "richeditor-link", size: "large" }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "tw-align-self-start typographies-heading-h1" },
          [_vm._v("CompassInput :")]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "container tw-flex-col" },
          [
            _c(
              "CompassInput",
              {
                ref: "input1",
                attrs: {
                  placeholder: "Mon icône est en slot",
                  error: _vm.hasError,
                  disabled: _vm.isDisabled,
                  size: "large"
                },
                on: {
                  input: function($event) {
                    return _vm.handleInput($event)
                  },
                  blur: function($event) {
                    return _vm.handleBlur($event)
                  },
                  focus: function($event) {
                    return _vm.handleFocus($event)
                  },
                  change: function($event) {
                    return _vm.handleChange($event)
                  }
                },
                model: {
                  value: _vm.inputModel,
                  callback: function($$v) {
                    _vm.inputModel = $$v
                  },
                  expression: "inputModel"
                }
              },
              [
                _c(
                  "template",
                  { slot: "prefix" },
                  [
                    _c("CompassIcon", {
                      attrs: { icon: "flash", size: "extra-small" }
                    })
                  ],
                  1
                )
              ],
              2
            ),
            _vm._v(" "),
            _c(
              "CompassInput",
              {
                ref: "input1",
                attrs: {
                  placeholder: "Mon icône est en slot",
                  error: _vm.hasError,
                  disabled: _vm.isDisabled,
                  size: "large"
                },
                on: {
                  input: function($event) {
                    return _vm.handleInput($event)
                  },
                  blur: function($event) {
                    return _vm.handleBlur($event)
                  },
                  focus: function($event) {
                    return _vm.handleFocus($event)
                  },
                  change: function($event) {
                    return _vm.handleChange($event)
                  }
                },
                model: {
                  value: _vm.inputModel,
                  callback: function($$v) {
                    _vm.inputModel = $$v
                  },
                  expression: "inputModel"
                }
              },
              [
                _c("template", { slot: "prefix" }, [
                  _c("p", [_vm._v("I'm a slot")])
                ])
              ],
              2
            ),
            _vm._v(" "),
            _c("CompassInput", {
              attrs: {
                "suffix-icon": "dashboard-fill",
                "prefix-icon": "heart",
                placeholder: "Placeholder",
                error: _vm.hasError,
                disabled: _vm.isDisabled,
                size: "medium"
              },
              on: {
                input: function($event) {
                  return _vm.handleInput($event)
                },
                blur: function($event) {
                  return _vm.handleBlur($event)
                },
                focus: function($event) {
                  return _vm.handleFocus($event)
                },
                change: function($event) {
                  return _vm.handleChange($event)
                }
              },
              model: {
                value: _vm.inputModel2,
                callback: function($$v) {
                  _vm.inputModel2 = $$v
                },
                expression: "inputModel2"
              }
            }),
            _vm._v(" "),
            _c("CompassInput", {
              attrs: {
                "suffix-icon": "dashboard-fill",
                "prefix-icon": "heart",
                placeholder: "Placeholder",
                error: _vm.hasError,
                disabled: _vm.isDisabled,
                size: "small"
              },
              on: {
                input: function($event) {
                  return _vm.handleInput($event)
                },
                blur: function($event) {
                  return _vm.handleBlur($event)
                },
                focus: function($event) {
                  return _vm.handleFocus($event)
                },
                change: function($event) {
                  return _vm.handleChange($event)
                }
              },
              model: {
                value: _vm.inputModel3,
                callback: function($$v) {
                  _vm.inputModel3 = $$v
                },
                expression: "inputModel3"
              }
            }),
            _vm._v(" "),
            _c("CompassInput", {
              attrs: {
                placeholder: "Placeholder",
                type: "textarea",
                error: _vm.hasError,
                disabled: _vm.isDisabled,
                size: "medium"
              },
              on: {
                input: function($event) {
                  return _vm.handleInput($event)
                },
                blur: function($event) {
                  return _vm.handleBlur($event)
                },
                focus: function($event) {
                  return _vm.handleFocus($event)
                },
                change: function($event) {
                  return _vm.handleChange($event)
                }
              },
              model: {
                value: _vm.inputModel4,
                callback: function($$v) {
                  _vm.inputModel4 = $$v
                },
                expression: "inputModel4"
              }
            }),
            _vm._v(" "),
            _c("div", [_vm._v(_vm._s(_vm.inputModel))]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "tw-flex tw-gap-[5px]" },
              [
                _c("CompassButton", {
                  attrs: {
                    label: "Focus input 1",
                    type: "secondary-destructive",
                    size: "large"
                  },
                  on: {
                    click: function($event) {
                      return _vm.$refs.input1.setFocus()
                    }
                  }
                }),
                _vm._v(" "),
                _c("CompassButton", {
                  attrs: {
                    label: "Trigger une error",
                    type: "primary-destructive",
                    size: "large"
                  },
                  on: { click: _vm.setError }
                }),
                _vm._v(" "),
                _c("CompassButton", {
                  attrs: {
                    label: "Trigger disabled",
                    type: "secondary-destructive",
                    size: "large"
                  },
                  on: { click: _vm.setDisabled }
                })
              ],
              1
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "tw-align-self-start typographies-heading-h1" },
          [_vm._v("CompassLink :")]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "container" },
          [
            _c("CompassLink", {
              attrs: {
                link: "https://google.com",
                target: "_blank",
                label: "Placeholder",
                "suffix-icon": "heart",
                type: "primary",
                size: "small"
              }
            }),
            _vm._v(" "),
            _c(
              "CompassLink",
              {
                attrs: {
                  label: "Placeholder",
                  type: "secondary",
                  size: "medium"
                },
                on: { click: _vm.handleClick }
              },
              [
                _c(
                  "template",
                  { slot: "suffix" },
                  [
                    _c("CompassIcon", {
                      attrs: { icon: "heart", size: "medium" }
                    })
                  ],
                  1
                )
              ],
              2
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "tw-align-self-start typographies-heading-h1" },
          [_vm._v("CompassLoader :")]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "container" },
          [
            _c("CompassLoader", { attrs: { size: "extra-small" } }),
            _vm._v(" "),
            _c("CompassLoader", { attrs: { size: "small" } }),
            _vm._v(" "),
            _c("CompassLoader"),
            _vm._v(" "),
            _c("CompassLoader", {
              attrs: { size: "large", color: "sellsy-brand-primary-100" }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "tw-align-self-start typographies-heading-h1" },
          [_vm._v("CompassLogo :")]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "container tw-flex-col" },
          [
            _c("CompassLogo", { attrs: { type: "icon", width: 30 } }),
            _vm._v(" "),
            _c("CompassLogo", { attrs: { type: "logo", width: 140 } })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "black container tw-flex-col" },
          [
            _c("CompassLogo", {
              attrs: { type: "icon", theme: "light", width: 24 }
            }),
            _vm._v(" "),
            _c("CompassLogo", {
              attrs: { type: "logo", theme: "light", width: 100 }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "tw-align-self-start typographies-heading-h1" },
          [_vm._v("CompassMenu :")]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "container tw-flex-col" },
          [
            _c(
              "CompassMenu",
              {
                attrs: { trigger: "hover" },
                on: {
                  "visible-change": _vm.handleVisibleChange,
                  open: _vm.handleOpen,
                  close: _vm.handleClose
                }
              },
              [
                _c("CompassButton", { attrs: { label: "Actions" } }),
                _vm._v(" "),
                _c(
                  "template",
                  { slot: "dropdown" },
                  [
                    _c("CompassMenuItem", {
                      attrs: { label: "item1" },
                      on: {
                        click: function($event) {
                          return _vm.handleLog("click on item 1")
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("CompassMenuItem", {
                      attrs: { label: "item 2", disabled: "" },
                      on: {
                        click: function($event) {
                          return _vm.handleLog("click on item 2")
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("CompassMenuItem", {
                      attrs: { label: "item 3" },
                      on: {
                        click: function($event) {
                          return _vm.handleLog("click on item 3")
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "CompassMenuGroup",
                      { attrs: { label: "SubMenu" } },
                      [
                        _c(
                          "template",
                          { slot: "dropdown" },
                          [
                            _c("CompassMenuItem", {
                              attrs: { label: "sub-item 1" },
                              on: {
                                click: function($event) {
                                  return _vm.handleLog("click on sub-item 1")
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("CompassMenuItem", {
                              attrs: { label: "sub-item 2" },
                              on: {
                                click: function($event) {
                                  return _vm.handleLog("click on sub-item 2")
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("CompassMenuItem", {
                              attrs: { label: "sub-item 3", disabled: "" },
                              on: {
                                click: function($event) {
                                  return _vm.handleLog("click on sub-item 3")
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("CompassMenuItem", {
                              attrs: { label: "sub-item 4" },
                              on: {
                                click: function($event) {
                                  return _vm.handleLog("click on sub-item 4")
                                }
                              }
                            })
                          ],
                          1
                        )
                      ],
                      2
                    )
                  ],
                  1
                )
              ],
              2
            ),
            _vm._v(" "),
            _c(
              "CompassMenu",
              {
                attrs: {
                  trigger: "click",
                  placement: "left-start",
                  "custom-class": "context-menu"
                }
              },
              [
                _c("CompassIconButton", { attrs: { icon: "action" } }),
                _vm._v(" "),
                _c(
                  "template",
                  { slot: "dropdown" },
                  [
                    _c("CompassMenuItem", {
                      attrs: { label: "Voir l'opportunité" }
                    }),
                    _vm._v(" "),
                    _c("CompassMenuItem", {
                      attrs: { label: "Voir dans un nouvel onglet" }
                    }),
                    _vm._v(" "),
                    _c("CompassMenuItem", { attrs: { label: "Modifier" } }),
                    _vm._v(" "),
                    _c(
                      "CompassMenuGroup",
                      {
                        attrs: {
                          label: "Changer l'étape",
                          placement: "left-start"
                        }
                      },
                      [
                        _c(
                          "template",
                          { slot: "dropdown" },
                          [
                            _c("CompassMenuItem", {
                              attrs: { label: "Piste - 0%" }
                            }),
                            _vm._v(" "),
                            _c("CompassMenuItem", {
                              attrs: { label: "Prospection - 10%" }
                            }),
                            _vm._v(" "),
                            _c("CompassMenuItem", {
                              attrs: { label: "Contact téléphonique - 20%" }
                            }),
                            _vm._v(" "),
                            _c("CompassMenuItem", {
                              attrs: { label: "Envoie de devis - 30%" }
                            }),
                            _vm._v(" "),
                            _c("CompassMenuItem", {
                              attrs: { label: "Negociation - 40%" }
                            }),
                            _vm._v(" "),
                            _c("CompassMenuItem", {
                              attrs: { label: "Devis signé - 70%" }
                            }),
                            _vm._v(" "),
                            _c("CompassMenuItem", {
                              attrs: {
                                label:
                                  "Super long text Super long text Super long text Super long text Super long text Super long text "
                              }
                            }),
                            _vm._v(" "),
                            _c("CompassMenuItem", {
                              attrs: { label: "Affaire conclue - 100%" }
                            }),
                            _vm._v(" "),
                            _c("CompassMenuItem", {
                              attrs: { label: "Affaire conclue - 100%" }
                            }),
                            _vm._v(" "),
                            _c("CompassMenuItem", {
                              attrs: { label: "Affaire conclue - 100%" }
                            }),
                            _vm._v(" "),
                            _c("CompassMenuItem", {
                              attrs: { label: "Affaire conclue - 100%" }
                            }),
                            _vm._v(" "),
                            _c("CompassMenuItem", {
                              attrs: { label: "Affaire conclue - 100%" }
                            }),
                            _vm._v(" "),
                            _c("CompassMenuItem", {
                              attrs: { label: "Affaire conclue - 100%" }
                            })
                          ],
                          1
                        )
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "CompassMenuGroup",
                      {
                        attrs: {
                          label: "Changer le statut",
                          placement: "left-start"
                        }
                      },
                      [
                        _c(
                          "template",
                          { slot: "dropdown" },
                          [
                            _c("CompassMenuItem", {
                              attrs: { label: "Annulée" }
                            }),
                            _vm._v(" "),
                            _c("CompassMenuItem", {
                              attrs: { label: "Fermée" }
                            }),
                            _vm._v(" "),
                            _c("CompassMenuItem", {
                              attrs: { label: "En retard" }
                            }),
                            _vm._v(" "),
                            _c("CompassMenuItem", {
                              attrs: { label: "Perdue" }
                            }),
                            _vm._v(" "),
                            _c("CompassMenuItem", {
                              attrs: { label: "Ouverte" }
                            }),
                            _vm._v(" "),
                            _c("CompassMenuItem", {
                              attrs: { label: "Gagnée" }
                            })
                          ],
                          1
                        )
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c("CompassMenuItem", { attrs: { label: "Supprimer" } })
                  ],
                  1
                )
              ],
              2
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "tw-align-self-start typographies-heading-h1" },
          [_vm._v("CompassMultiAvatar :")]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "container" },
          [
            _c("CompassMultiAvatar", {
              attrs: {
                size: "extra-large",
                avatars: [
                  {
                    photo:
                      "https://i-mom.unimedias.fr/2022/03/14/chat.jpg?auto=format%2Ccompress&crop=faces&cs=tinysrgb&fit=crop&h=591&w=1050",
                    initials: "HS",
                    fullname: "Homer Simpson",
                    avatarColorType:
                      "bg-component-background-avatar-random-pink"
                  },
                  {
                    initials: "TS",
                    fullname: "Thibaut Super Schmutz",
                    avatarColorType:
                      "bg-component-background-avatar-random-green"
                  },
                  {
                    initials: "CJ",
                    fullname: "Cévric Julia",
                    avatarColorType:
                      "bg-component-background-avatar-random-yellow",
                    stateBadge: "deactivated"
                  },
                  {
                    initials: "VK",
                    fullname: "Vincent Kraus",
                    avatarColorType:
                      "bg-component-background-avatar-random-pink",
                    stateBadge: "removed"
                  },
                  {
                    initials: "SP",
                    fullname: "Sébastien Portrait",
                    avatarColorType:
                      "bg-component-background-avatar-random-pink"
                  },
                  {
                    initials: "MY",
                    fullname: "Magalie Yang",
                    avatarColorType:
                      "bg-component-background-avatar-random-green"
                  },
                  {
                    initials: "TF",
                    fullname: "Thomas Feuillatre",
                    avatarColorType:
                      "bg-component-background-avatar-random-pink"
                  },
                  {
                    initials: "NA",
                    fullname: "Neil Appleton",
                    avatarColorType:
                      "bg-component-background-avatar-random-yellow"
                  }
                ]
              }
            }),
            _vm._v(" "),
            _c("CompassMultiAvatar", {
              attrs: {
                avatars: [
                  {
                    initials: "mj",
                    fullname: "Michael Jordan",
                    avatarColorType:
                      "bg-component-background-avatar-random-pink"
                  },
                  {
                    initials: "km",
                    fullname: "Karl Malone",
                    avatarColorType:
                      "bg-component-background-avatar-random-green"
                  }
                ]
              }
            }),
            _vm._v(" "),
            _c("CompassMultiAvatar", {
              attrs: {
                size: "small",
                avatars: [
                  {
                    photo: "https://i.pravatar.cc/300",
                    initials: "xx",
                    fullname: "Michael Jordan",
                    avatarColorType:
                      "bg-component-background-avatar-random-pink"
                  },
                  {
                    photo: "https://i.pravatar.cc/300",
                    initials: "TS",
                    fullname: "Scottie Pippen",
                    avatarColorType:
                      "bg-component-background-avatar-random-green"
                  },
                  {
                    photo: "https://i.pravatar.cc/300",
                    initials: "TS",
                    fullname: "Ron Harper",
                    avatarColorType:
                      "bg-component-background-avatar-random-green"
                  },
                  {
                    photo: "https://i.pravatar.cc/300",
                    initials: "TS",
                    fullname: "Tony Kukoc",
                    avatarColorType:
                      "bg-component-background-avatar-random-green"
                  },
                  {
                    photo: "https://i.pravatar.cc/300",
                    initials: "TS",
                    fullname: "Dennis Rodman",
                    avatarColorType:
                      "bg-component-background-avatar-random-green"
                  },
                  {
                    photo: "https://i.pravatar.cc/300",
                    initials: "TS",
                    fullname: "Steve Kerr",
                    avatarColorType:
                      "bg-component-background-avatar-random-green"
                  }
                ]
              }
            }),
            _vm._v(" "),
            _c("CompassMultiAvatar", {
              attrs: {
                size: "extra-small",
                avatars: [
                  {
                    initials: "xx",
                    fullname: "Michael Jordan",
                    avatarColorType:
                      "bg-component-background-avatar-random-pink",
                    stateBadge: "removed"
                  },
                  {
                    initials: "TS",
                    fullname: "Scottie Pippen",
                    avatarColorType:
                      "bg-component-background-avatar-random-green"
                  }
                ]
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "tw-align-self-start typographies-heading-h1" },
          [_vm._v("CompassNumberInput :")]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "container tw-flex-col" },
          [
            _c("CompassNumberInput", {
              attrs: { "model-value": _vm.numberInput1, min: 0, max: 0 },
              on: {
                change: function(val) {
                  return (_vm.numberInput1 = val)
                }
              }
            }),
            _vm._v(" "),
            _c("CompassNumberInput", {
              attrs: {
                "model-value": _vm.numberInput2,
                min: -10,
                max: 10,
                step: 10,
                size: "large",
                disabled: false,
                error: false,
                placeholder: "0"
              },
              on: {
                change: function(val) {
                  return (_vm.numberInput2 = val)
                }
              }
            }),
            _vm._v(" "),
            _c("CompassNumberInput", {
              attrs: { "model-value": _vm.numberInput3, disabled: "" },
              on: {
                change: function(val) {
                  return (_vm.numberInput3 = val)
                }
              }
            }),
            _vm._v(" "),
            _c("CompassNumberInput", {
              attrs: {
                "model-value": _vm.numberInput4,
                size: "small",
                error: ""
              },
              on: {
                change: function(val) {
                  return (_vm.numberInput4 = val)
                }
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "tw-align-self-start typographies-heading-h1" },
          [_vm._v("CompassObject :")]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "container" },
          [
            _c("CompassObject", {
              attrs: {
                object: "accounting",
                label: "I'm an object",
                caption: "I'm a caption"
              }
            }),
            _vm._v(" "),
            _c("CompassObject", {
              attrs: {
                label: "I'm an object",
                caption: "I'm a caption",
                size: "extra-large",
                type: "removed"
              }
            }),
            _vm._v(" "),
            _c("CompassObject", {
              attrs: { object: "payment", size: "extra-small" }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "tw-align-self-start typographies-heading-h1" },
          [_vm._v("CompassPanel :")]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "container tw-flex-col" },
          [
            _c("CompassButton", {
              attrs: { label: "Open Panel 1 (small + no overflow)" },
              on: {
                click: function($event) {
                  _vm.openPanelOne = true
                }
              }
            }),
            _vm._v(" "),
            _c(
              "CompassPanel",
              {
                attrs: {
                  size: "small",
                  title:
                    "Panel 1 Title qui est finalement assez long et va probablement sur une deuxième ligne parce que bon il faut voir ce que ça donne quand même",
                  "primary-action": {
                    label: "Placeholder",
                    action: function() {
                      return _vm.handleLog("primaryAction clicked")
                    }
                  },
                  "secondary-actions": [
                    {
                      label: "Placeholder",
                      action: function() {
                        return _vm.handleLog("secondaryAction1 clicked")
                      }
                    },
                    {
                      label: "Placeholder",
                      action: function() {
                        return _vm.handleLog("secondaryAction2 clicked")
                      }
                    }
                  ]
                },
                on: {
                  opened: function($event) {
                    return _vm.handleLog("panel 1 is open")
                  },
                  closed: function($event) {
                    return _vm.handleLog("panel 1 is closed")
                  }
                },
                model: {
                  value: _vm.openPanelOne,
                  callback: function($$v) {
                    _vm.openPanelOne = $$v
                  },
                  expression: "openPanelOne"
                }
              },
              _vm._l(5, function(_, index) {
                return _c(
                  "p",
                  {
                    key: "panel-content-" + index,
                    staticStyle: { margin: "0px" }
                  },
                  [
                    _vm._v(
                      "\n                    Panel Content\n                "
                    )
                  ]
                )
              }),
              0
            ),
            _vm._v(" "),
            _c("CompassButton", {
              attrs: { label: "Open Panel 2 (large + overflow)" },
              on: {
                click: function($event) {
                  _vm.openPanelTwo = true
                }
              }
            }),
            _vm._v(" "),
            _c(
              "CompassPanel",
              {
                attrs: {
                  size: "large",
                  title: "Panel 1 Title",
                  "primary-action": {
                    label: "Placeholder",
                    action: function() {
                      return _vm.handleLog("primaryAction clicked")
                    }
                  },
                  "secondary-actions": [
                    {
                      label: "Placeholder",
                      action: function() {
                        return _vm.handleLog("secondaryAction1 clicked")
                      }
                    },
                    {
                      label: "Placeholder",
                      action: function() {
                        return _vm.handleLog("secondaryAction2 clicked")
                      }
                    }
                  ]
                },
                on: {
                  opened: function($event) {
                    return _vm.handleLog("panel 2 is open")
                  },
                  closed: function($event) {
                    return _vm.handleLog("panel 2 is closed")
                  }
                },
                model: {
                  value: _vm.openPanelTwo,
                  callback: function($$v) {
                    _vm.openPanelTwo = $$v
                  },
                  expression: "openPanelTwo"
                }
              },
              _vm._l(70, function(_, index) {
                return _c(
                  "p",
                  {
                    key: "panel-content-" + index,
                    staticStyle: { margin: "0px" }
                  },
                  [
                    _vm._v(
                      "\n                    Panel Content\n                "
                    )
                  ]
                )
              }),
              0
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "tw-align-self-start typographies-heading-h1" },
          [_vm._v("CompassPassword :")]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "container" },
          [
            _c("CompassPassword", {
              attrs: { "show-text": "Voir", "hide-text": "Hide" },
              model: {
                value: _vm.passwordValue,
                callback: function($$v) {
                  _vm.passwordValue = $$v
                },
                expression: "passwordValue"
              }
            }),
            _vm._v(" "),
            _c("CompassPassword", {
              attrs: {
                "show-text": "Show",
                "hide-text": "Masquer",
                rules: _vm.passwordRules,
                size: "large",
                disabled: true
              },
              on: {
                input: function($event) {
                  return _vm.handleInput($event)
                },
                blur: function($event) {
                  return _vm.handleBlur($event)
                },
                focus: function($event) {
                  return _vm.handleFocus($event)
                },
                change: function($event) {
                  return _vm.handleChange($event)
                }
              },
              model: {
                value: _vm.passwordValue2,
                callback: function($$v) {
                  _vm.passwordValue2 = $$v
                },
                expression: "passwordValue2"
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "tw-align-self-start typographies-heading-h1" },
          [_vm._v("CompassProgressBar :")]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "container" },
          [
            _c("CompassProgressBar", { attrs: { state: 44 } }),
            _vm._v(" "),
            _c("CompassProgressBar", { attrs: { state: 46 } }),
            _vm._v(" "),
            _c("CompassProgressBar", { attrs: { state: 84 } }),
            _vm._v(" "),
            _c("CompassProgressBar", {
              attrs: { state: _vm.progress, caption: "15 jours restants" }
            }),
            _vm._v(" "),
            _c("CompassProgressBar", {
              attrs: { state: 100, caption: "2 jours restants" }
            }),
            _vm._v(" "),
            _c("CompassProgressBar", {
              attrs: { state: 66, type: "colored", caption: "2 jours restants" }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "tw-align-self-start typographies-heading-h1" },
          [_vm._v("CompassRadio :")]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "container tw-flex-col" }, [
          _c(
            "div",
            { staticClass: "tw-flex tw-flex-col tw-items-start tw-gap-2" },
            [
              _c("CompassRadio", { attrs: { "model-value": "modelChecked1" } }),
              _vm._v(" "),
              _c("CompassRadio", {
                attrs: { "model-value": "modelChecked2 checked", checked: "" }
              }),
              _vm._v(" "),
              _c("CompassRadio", {
                attrs: { "model-value": "modelChecked3 small", size: "small" }
              }),
              _vm._v(" "),
              _c("CompassRadio", {
                attrs: {
                  "model-value": "modelChecked4 large disabled",
                  size: "large",
                  disabled: ""
                }
              }),
              _vm._v(" "),
              _c("CompassRadio", {
                attrs: { "model-value": "modelChecked5 error", error: "" }
              })
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "tw-align-self-start typographies-heading-h1" },
          [_vm._v("CompassRadioGroup :")]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "container tw-flex-col" }, [
          _c(
            "div",
            { staticClass: "tw-flex tw-flex-col tw-items-start tw-gap-4" },
            [
              _c(
                "CompassRadioGroup",
                {
                  attrs: {
                    label: "RadioGroup horizontal medium",
                    direction: "horizontal",
                    size: "medium"
                  },
                  model: {
                    value: _vm.radioGroupModel,
                    callback: function($$v) {
                      _vm.radioGroupModel = $$v
                    },
                    expression: "radioGroupModel"
                  }
                },
                [
                  _c("CompassRadio", {
                    attrs: { "model-value": "small", size: "small" }
                  }),
                  _vm._v(" "),
                  _c("CompassRadio", {
                    attrs: { "model-value": "medium", size: "medium" }
                  }),
                  _vm._v(" "),
                  _c("CompassRadio", {
                    attrs: { "model-value": "large", size: "large" }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "CompassRadioGroup",
                {
                  attrs: {
                    label: "RadioGroup vertical small",
                    direction: "vertical",
                    size: "small"
                  },
                  model: {
                    value: _vm.radioGroupModel2,
                    callback: function($$v) {
                      _vm.radioGroupModel2 = $$v
                    },
                    expression: "radioGroupModel2"
                  }
                },
                [
                  _c("CompassRadio", {
                    attrs: { "model-value": "MyValue", size: "small" }
                  }),
                  _vm._v(" "),
                  _c("CompassRadio", {
                    attrs: {
                      "model-value": "MyValue2",
                      size: "medium",
                      disabled: ""
                    }
                  }),
                  _vm._v(" "),
                  _c("CompassRadio", {
                    attrs: {
                      "model-value": "MyValue3",
                      size: "large",
                      error: ""
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "CompassRadioGroup",
                {
                  attrs: {
                    label: "RadioGroup horizontal large",
                    direction: "horizontal",
                    size: "large"
                  },
                  model: {
                    value: _vm.radioGroupModel3,
                    callback: function($$v) {
                      _vm.radioGroupModel3 = $$v
                    },
                    expression: "radioGroupModel3"
                  }
                },
                [
                  _c("CompassRadio", {
                    attrs: { "model-value": "MyValue small", size: "small" }
                  }),
                  _vm._v(" "),
                  _c("CompassRadio", {
                    attrs: {
                      "model-value": "MyValue2 medium checked",
                      size: "medium",
                      checked: ""
                    }
                  }),
                  _vm._v(" "),
                  _c("CompassRadio", {
                    attrs: { "model-value": "MyValue3 large", size: "large" }
                  })
                ],
                1
              )
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "tw-align-self-start typographies-heading-h1" },
          [_vm._v("CompassToggleButton :")]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "container tw-flex-col" }, [
          _c(
            "div",
            { staticClass: "tw-flex tw-flex-row tw-items-start tw-gap-4" },
            [
              _c("CompassToggleButton", {
                attrs: { value: "Medium 1", icon: "heart-fill" }
              }),
              _vm._v(" "),
              _c("CompassToggleButton", { attrs: { value: "Medium 2" } }),
              _vm._v(" "),
              _c("CompassToggleButton", {
                attrs: { value: "Medium 3", disabled: "" }
              }),
              _vm._v(" "),
              _c("CompassToggleButton", {
                attrs: { value: "Medium 4", "show-dot": "" }
              }),
              _vm._v(" "),
              _c("CompassToggleButton", {
                attrs: { value: "Medium 5", disabled: "", "show-dot": "" }
              }),
              _vm._v(" "),
              _c("CompassToggleButton", {
                attrs: { value: "Medium 6", badge: 2 }
              }),
              _vm._v(" "),
              _c("CompassToggleButton", {
                attrs: { value: "Medium 7", badge: 2, disabled: "" }
              }),
              _vm._v(" "),
              _c("CompassToggleButton", {
                attrs: {
                  value: "Medium 8",
                  badge: 2,
                  disabled: "",
                  "show-dot": ""
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "tw-flex tw-flex-row tw-items-start tw-gap-4" },
            [
              _c("CompassToggleButton", {
                attrs: { value: "Large 1", size: "large", icon: "heart-fill" }
              }),
              _vm._v(" "),
              _c("CompassToggleButton", {
                attrs: { value: "Large 2", size: "large" }
              }),
              _vm._v(" "),
              _c("CompassToggleButton", {
                attrs: { value: "Large 3", size: "large", disabled: "" }
              }),
              _vm._v(" "),
              _c("CompassToggleButton", {
                attrs: { value: "Large 4", size: "large", "show-dot": "" }
              }),
              _vm._v(" "),
              _c("CompassToggleButton", {
                attrs: {
                  value: "Large 5",
                  size: "large",
                  disabled: "",
                  "show-dot": ""
                }
              }),
              _vm._v(" "),
              _c("CompassToggleButton", {
                attrs: { value: "Large 6", size: "large", badge: 2 }
              }),
              _vm._v(" "),
              _c("CompassToggleButton", {
                attrs: {
                  value: "Large 7",
                  size: "large",
                  badge: 2,
                  disabled: ""
                }
              }),
              _vm._v(" "),
              _c("CompassToggleButton", {
                attrs: {
                  value: "Large 8",
                  size: "large",
                  badge: 2,
                  disabled: "",
                  "show-dot": ""
                }
              })
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "tw-align-self-start typographies-heading-h1" },
          [_vm._v("\n            CompassToggleButtonGroup :\n        ")]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "container tw-flex-col" }, [
          _c(
            "div",
            { staticClass: "tw-flex tw-flex-row tw-items-start tw-gap-4" },
            [
              _c(
                "CompassToggleButtonGroup",
                {
                  model: {
                    value: _vm.toggleGroup1,
                    callback: function($$v) {
                      _vm.toggleGroup1 = $$v
                    },
                    expression: "toggleGroup1"
                  }
                },
                [
                  _c("CompassToggleButton", {
                    attrs: { value: "Medium 1", icon: "heart-fill" }
                  }),
                  _vm._v(" "),
                  _c("CompassToggleButton", { attrs: { value: "Medium 2" } }),
                  _vm._v(" "),
                  _c("CompassToggleButton", {
                    attrs: { value: "Medium 3", disabled: "" }
                  }),
                  _vm._v(" "),
                  _c("CompassToggleButton", {
                    attrs: { value: "Medium 4", "show-dot": "" }
                  }),
                  _vm._v(" "),
                  _c("CompassToggleButton", {
                    attrs: { value: "Medium 5", disabled: "", "show-dot": "" }
                  }),
                  _vm._v(" "),
                  _c("CompassToggleButton", {
                    attrs: { value: "Medium 6", badge: 2 }
                  }),
                  _vm._v(" "),
                  _c("CompassToggleButton", {
                    attrs: { value: "Medium 7", badge: 2, disabled: "" }
                  }),
                  _vm._v(" "),
                  _c("CompassToggleButton", {
                    attrs: {
                      value: "Medium 8",
                      badge: 2,
                      disabled: "",
                      "show-dot": ""
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "tw-flex tw-flex-row tw-items-start tw-gap-4" },
            [
              _c(
                "CompassToggleButtonGroup",
                {
                  attrs: { value: "Large 4", size: "large", exclusive: true },
                  model: {
                    value: _vm.toggleGroup2,
                    callback: function($$v) {
                      _vm.toggleGroup2 = $$v
                    },
                    expression: "toggleGroup2"
                  }
                },
                [
                  _c("CompassToggleButton", {
                    attrs: { value: "Large 1", icon: "heart-fill" }
                  }),
                  _vm._v(" "),
                  _c("CompassToggleButton", { attrs: { value: "Large 2" } }),
                  _vm._v(" "),
                  _c("CompassToggleButton", {
                    attrs: { value: "Large 34", disabled: "" }
                  }),
                  _vm._v(" "),
                  _c("CompassToggleButton", {
                    attrs: { value: "Large 4", "show-dot": "" }
                  }),
                  _vm._v(" "),
                  _c("CompassToggleButton", {
                    attrs: { value: "Large 5", disabled: "", "show-dot": "" }
                  }),
                  _vm._v(" "),
                  _c("CompassToggleButton", {
                    attrs: { value: "Large 6", badge: 2 }
                  }),
                  _vm._v(" "),
                  _c("CompassToggleButton", {
                    attrs: { value: "Large 7", badge: 2, disabled: "" }
                  }),
                  _vm._v(" "),
                  _c("CompassToggleButton", {
                    attrs: {
                      value: "Large 8",
                      badge: 2,
                      disabled: "",
                      "show-dot": ""
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "tw-flex tw-flex-row tw-items-start tw-gap-4" },
            [
              _c(
                "CompassToggleButtonGroup",
                {
                  attrs: {
                    value: "Large 4",
                    size: "large",
                    disabled: "",
                    exclusive: true
                  },
                  model: {
                    value: _vm.toggleGroup3,
                    callback: function($$v) {
                      _vm.toggleGroup3 = $$v
                    },
                    expression: "toggleGroup3"
                  }
                },
                [
                  _c("CompassToggleButton", {
                    attrs: { value: "Large 1", icon: "heart-fill" }
                  }),
                  _vm._v(" "),
                  _c("CompassToggleButton", { attrs: { value: "Large 2" } }),
                  _vm._v(" "),
                  _c("CompassToggleButton", {
                    attrs: { value: "Large 36", disabled: "" }
                  }),
                  _vm._v(" "),
                  _c("CompassToggleButton", {
                    attrs: { value: "Large 4", "show-dot": "" }
                  }),
                  _vm._v(" "),
                  _c("CompassToggleButton", {
                    attrs: { value: "Large 5", disabled: "", "show-dot": "" }
                  }),
                  _vm._v(" "),
                  _c("CompassToggleButton", {
                    attrs: { value: "Large 6", badge: 2 }
                  }),
                  _vm._v(" "),
                  _c("CompassToggleButton", {
                    attrs: { value: "Large 7", badge: 2, disabled: "" }
                  }),
                  _vm._v(" "),
                  _c("CompassToggleButton", {
                    attrs: {
                      value: "Large 8",
                      badge: 2,
                      disabled: "",
                      "show-dot": ""
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "tw-align-self-start typographies-heading-h1" },
          [_vm._v("CompassSelect :")]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "container" },
          [
            _c(
              "CompassSelect",
              {
                attrs: {
                  placeholder: "Hello there",
                  "prefix-icon": "heart",
                  size: "large",
                  "menu-class": "testNeil"
                },
                on: { blur: _vm.handleBlur, focus: _vm.handleFocus },
                model: {
                  value: _vm.selectModel,
                  callback: function($$v) {
                    _vm.selectModel = $$v
                  },
                  expression: "selectModel"
                }
              },
              _vm._l(220, function(_, index) {
                return _c(
                  "CompassDropdownSelectOption",
                  _vm._b(
                    { key: index },
                    "CompassDropdownSelectOption",
                    { label: "My label " + index, value: "option-" + index },
                    false
                  ),
                  [
                    _vm._v(
                      "\n                    Option content\n                "
                    )
                  ]
                )
              }),
              1
            ),
            _vm._v(" "),
            _c(
              "CompassSelect",
              {
                attrs: {
                  placeholder: "Link at the end of options",
                  size: "large",
                  actions: [
                    { label: "Click me", callback: _vm.handleClick },
                    {
                      label: "I am disabled uwu",
                      callback: _vm.handleClick,
                      disabled: true
                    }
                  ]
                },
                model: {
                  value: _vm.selectModel4,
                  callback: function($$v) {
                    _vm.selectModel4 = $$v
                  },
                  expression: "selectModel4"
                }
              },
              _vm._l(_vm.selectOptions, function(option) {
                return _c(
                  "CompassDropdownSelectOption",
                  _vm._b(
                    { key: option.value },
                    "CompassDropdownSelectOption",
                    option,
                    false
                  )
                )
              }),
              1
            ),
            _vm._v(" "),
            _c("CompassSelect", {
              attrs: {
                placeholder: "No option but link",
                size: "large",
                actions: [{ label: "Click me", callback: _vm.handleClick }]
              },
              model: {
                value: _vm.selectModel6,
                callback: function($$v) {
                  _vm.selectModel6 = $$v
                },
                expression: "selectModel6"
              }
            }),
            _vm._v(" "),
            _c("CompassSelect", {
              attrs: { placeholder: "no options" },
              model: {
                value: _vm.selectModel7,
                callback: function($$v) {
                  _vm.selectModel7 = $$v
                },
                expression: "selectModel7"
              }
            }),
            _vm._v(" "),
            _c(
              "CompassSelect",
              {
                attrs: { placeholder: "General Kenobi" },
                on: { blur: _vm.handleBlur, focus: _vm.handleFocus },
                model: {
                  value: _vm.selectModel2,
                  callback: function($$v) {
                    _vm.selectModel2 = $$v
                  },
                  expression: "selectModel2"
                }
              },
              _vm._l(_vm.selectOptions, function(option) {
                return _c(
                  "CompassDropdownSelectOption",
                  _vm._b(
                    { key: option.value },
                    "CompassDropdownSelectOption",
                    option,
                    false
                  )
                )
              }),
              1
            ),
            _vm._v(" "),
            _c(
              "CompassSelect",
              {
                attrs: { size: "small" },
                on: { blur: _vm.handleBlur, focus: _vm.handleFocus },
                model: {
                  value: _vm.selectModel3,
                  callback: function($$v) {
                    _vm.selectModel3 = $$v
                  },
                  expression: "selectModel3"
                }
              },
              _vm._l(_vm.selectOptions, function(option) {
                return _c(
                  "CompassDropdownSelectOption",
                  _vm._b(
                    { key: option.value },
                    "CompassDropdownSelectOption",
                    option,
                    false
                  )
                )
              }),
              1
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "container" },
          [
            _c(
              "CompassSelect",
              {
                attrs: { size: "large" },
                on: { blur: _vm.handleBlur, focus: _vm.handleFocus },
                model: {
                  value: _vm.selectModel5,
                  callback: function($$v) {
                    _vm.selectModel5 = $$v
                  },
                  expression: "selectModel5"
                }
              },
              _vm._l(_vm.selectGroupOptions, function(group) {
                return _c(
                  "CompassOptionGroup",
                  { key: group.label, attrs: { label: group.label } },
                  _vm._l(group.options, function(item) {
                    return _c("CompassDropdownSelectOption", {
                      key: item.value,
                      attrs: { label: item.label, value: item.value }
                    })
                  }),
                  1
                )
              }),
              1
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "CompassFormItem",
          {
            staticClass: "tw-m-auto tw-w-[150px]",
            attrs: {
              error: _vm.isErrorSelectMultiple ? "Aucun choix" : "",
              label: ""
            }
          },
          [
            _c(
              "CompassSelect",
              {
                attrs: {
                  multiple: true,
                  filterable: true,
                  error: _vm.isErrorSelectMultiple,
                  size: "medium",
                  actions: [
                    { label: "Click me", callback: _vm.handleClick },
                    {
                      label: "I am disabled uwu",
                      callback: _vm.handleClick,
                      disabled: true
                    }
                  ]
                },
                model: {
                  value: _vm.selectModelMultiple,
                  callback: function($$v) {
                    _vm.selectModelMultiple = $$v
                  },
                  expression: "selectModelMultiple"
                }
              },
              _vm._l(_vm.selectOptionsMultiple, function(option) {
                return _c(
                  "CompassDropdownSelectOption",
                  _vm._b(
                    { key: option.value },
                    "CompassDropdownSelectOption",
                    option,
                    false
                  )
                )
              }),
              1
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "CompassSelect",
          {
            staticClass: "tw-m-auto tw-w-[150px]",
            attrs: {
              multiple: true,
              error: _vm.isErrorSelectMultiple,
              "multiple-limite": 2,
              disabled: true
            },
            model: {
              value: _vm.selectModelMultiple,
              callback: function($$v) {
                _vm.selectModelMultiple = $$v
              },
              expression: "selectModelMultiple"
            }
          },
          _vm._l(_vm.selectOptionsMultiple, function(option) {
            return _c(
              "CompassDropdownSelectOption",
              _vm._b(
                { key: option.value },
                "CompassDropdownSelectOption",
                option,
                false
              )
            )
          }),
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "container" },
          [
            _c("p", [_vm._v("Filterable")]),
            _vm._v(" "),
            _c(
              "CompassSelect",
              {
                attrs: {
                  placeholder: "Hello there",
                  "prefix-icon": "heart",
                  filterable: "",
                  size: "large"
                },
                model: {
                  value: _vm.selectModel,
                  callback: function($$v) {
                    _vm.selectModel = $$v
                  },
                  expression: "selectModel"
                }
              },
              _vm._l(200, function(_, index) {
                return _c(
                  "CompassDropdownSelectOption",
                  _vm._b(
                    { key: index },
                    "CompassDropdownSelectOption",
                    { label: "My label " + index, value: "option-" + index },
                    false
                  ),
                  [
                    _vm._v(
                      "\n                    Option content\n                "
                    )
                  ]
                )
              }),
              1
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "tw-align-self-start typographies-heading-h1" },
          [_vm._v("CompassSideNav :")]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "container" },
          [
            _c("CompassSideNav", {
              attrs: { "menu-items": _vm.menuItems },
              on: {
                open: _vm.handleSideNavOpen,
                select: _vm.handleSideNavSelect
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "tw-align-self-start typographies-heading-h1" },
          [_vm._v("CompassSplitButton :")]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "black container" },
          [
            _c("CompassSplitButton", {
              attrs: { size: "small", type: "primary", label: "Placeholder" },
              on: {
                clickOnLabel: _vm.handleClick,
                clickOnArrow: _vm.handleClick
              }
            }),
            _vm._v(" "),
            _c("CompassSplitButton", {
              attrs: {
                size: "small",
                type: "primary",
                label: "Placeholder",
                disabled: ""
              }
            }),
            _vm._v(" "),
            _c("CompassSplitButton", {
              attrs: { size: "medium", type: "secondary", label: "Placeholder" }
            }),
            _vm._v(" "),
            _c("CompassSplitButton", {
              attrs: {
                size: "large",
                type: "secondary-contrast",
                label: "Placeholder"
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "tw-align-self-start typographies-heading-h1" },
          [_vm._v("CompassSwitch :")]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "container tw-flex-col" },
          [
            _c("CompassSwitch", {
              attrs: { size: "large" },
              model: {
                value: _vm.switchModel,
                callback: function($$v) {
                  _vm.switchModel = $$v
                },
                expression: "switchModel"
              }
            }),
            _vm._v(" "),
            _c("CompassSwitch", {
              attrs: {
                size: "small",
                "active-value": "bonjour",
                "inactive-value": "coucou",
                label: "Label pour Switch 2"
              },
              model: {
                value: _vm.switchModel2,
                callback: function($$v) {
                  _vm.switchModel2 = $$v
                },
                expression: "switchModel2"
              }
            }),
            _vm._v(" "),
            _c("CompassSwitch", {
              attrs: {
                size: "medium",
                "active-value": 2,
                "inactive-value": "fdgdf",
                label: "Label pour Switch 3",
                disabled: "",
                orientation: "right"
              },
              model: {
                value: _vm.switchModel3,
                callback: function($$v) {
                  _vm.switchModel3 = $$v
                },
                expression: "switchModel3"
              }
            }),
            _vm._v(" "),
            _c("CompassSwitch", {
              attrs: {
                size: "medium",
                "active-value": 2,
                "inactive-value": "fdgdf",
                label: "Label pour Switch 3",
                disabled: "",
                orientation: "left"
              },
              model: {
                value: _vm.switchModel3,
                callback: function($$v) {
                  _vm.switchModel3 = $$v
                },
                expression: "switchModel3"
              }
            }),
            _vm._v(" "),
            _c("CompassSwitch", {
              attrs: {
                size: "large",
                "active-value": "perroquet",
                "inactive-value": "perruche",
                label: "Label pour Switch 4"
              },
              model: {
                value: _vm.switchModel4,
                callback: function($$v) {
                  _vm.switchModel4 = $$v
                },
                expression: "switchModel4"
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "tw-align-self-start typographies-heading-h1" },
          [_vm._v("CompassTable :")]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "container tw-flex-col" },
          [
            _c(
              "CompassTable",
              {
                staticStyle: { width: "1050px", height: "480px" },
                attrs: {
                  columns: [
                    {
                      name: "active",
                      label: "Actif"
                    },
                    {
                      name: "firstname",
                      label: "Prénom(s)",
                      fixed: true,
                      width: 297
                    },
                    {
                      name: "name",
                      label: "Nom",
                      fixed: true,
                      sortable: true,
                      width: 155
                    },
                    {
                      name: "age",
                      label: "Age",
                      sortable: true,
                      fixed: true,
                      width: 90
                    },
                    {
                      name: "job",
                      label: "emploi",
                      sortable: false
                    },
                    { name: "address", label: "Adresse", fixed: false },
                    { name: "city", label: "Ville", sortalbe: true },
                    { name: "postalCode", label: "Code postal", width: 150 },
                    { name: "phone", label: "Téléphone", width: 100 },
                    {
                      name: "email",
                      label: "Adresse éléctronique",
                      sortable: true
                    },
                    { name: "fax", label: "Fax" }
                  ],
                  rows: [
                    {
                      age: "32",
                      active: {
                        component: "CompassRadio",
                        caption: "component exemple",
                        props: {
                          modelValue: true,
                          label: "exemple",
                          type: "secondary"
                        }
                      },
                      name: "ABC",
                      subrowAction: null,
                      firstname: "empty name + fixed subrow",
                      phone: "0412345678",
                      selectable: true,
                      expandable: true,
                      fixSubrow: true,
                      subrow:
                        "Ceci est un subrow qui passe par un slot, et est géré par data rows"
                    },
                    {
                      age: "12",
                      subrowAction: null,
                      name: {
                        component: "CompassButton",
                        props: { label: "button" }
                      },
                      firstname: "cpmponent name",
                      phone: "0412345678",
                      selectable: true,
                      expandable: true,
                      job: {
                        component: "CompassObject",
                        caption: "ceci est un Objet",
                        props: {
                          caption: "caption",
                          label: "Poste"
                        }
                      },
                      subrow: {
                        component: "CompassObject",
                        caption: "ceci est un Objet",
                        props: {
                          caption: "caption",
                          label: "Poste"
                        }
                      }
                    },
                    {
                      name: "subrow vide",
                      job: "Data scientist",
                      email: "Mariah@company.fr",
                      firstname: "ABC",
                      showSubrow: true,
                      subrow: "100.23"
                    },

                    { name: "ZZZ", firstname: "Lewis", job: "Chef de projet" },
                    {
                      age: "82",
                      subrowAction: null,
                      name: "",
                      firstname: "empty name",
                      phone: "0412345678",
                      selectable: true,
                      expandable: true,
                      subrow:
                        "Ceci est un subrow qui passe par un slot, et est géré par data rows"
                    },
                    {
                      age: "39",
                      subrowAction: null,
                      firstname: "table component - no name",
                      phone: "0412345678",
                      selectable: true,
                      expandable: true,
                      subrow: {
                        component: "CompassTable",
                        props: {
                          columns: [
                            { name: "name", label: "Nom" },
                            { name: "firstname", label: "Prénom" },
                            { name: "location", label: "Adresse Principale" },
                            { name: "other", label: "Autre" }
                          ],
                          rows: [
                            {
                              name: "Parker",
                              firstname: "Peter",
                              location: "Queens - New York",
                              other: ""
                            },
                            {
                              name: "Morales",
                              firstname: "Miles",
                              location: "Bronx",
                              other: "Too young to be an hero"
                            },
                            {
                              name: "Stacy",
                              firstname: "Gwen",
                              location: "",
                              other: "Sometimes called Spider-gwen"
                            },
                            {
                              name: "",
                              firstname: "",
                              location: "",
                              other:
                                "No one know the true identity of Spider-pig"
                            },
                            {
                              name: "Parker",
                              firstname: "Peter",
                              location: "",
                              other:
                                "Called Spider-man noir, dub by Nicolas Cage"
                            }
                          ]
                        }
                      }
                    },
                    {
                      age: "31",
                      subrowAction: null,
                      expandable: true,
                      firstname: "no name",
                      subrow: {
                        component: "CompassProgressBar",
                        props: {
                          state: 40,
                          caption: "caption",
                          type: "default"
                        }
                      }
                    },
                    {
                      age: "32.4",
                      subrowAction: null,
                      name: "",
                      firstname: "empty name",
                      phone: "0412345678",
                      selectable: true,
                      expandable: true,
                      subrow:
                        "Ceci est un subrow qui passe par un slot, et est géré par data rows"
                    },
                    {
                      name: "Bernadinet",
                      age: "42.99",
                      job: "Developer",
                      subrowAction: null,
                      subrowAction: null,
                      city: "La Rochelle",
                      fax: "04.12.34.56.78",
                      phone: "01.12.34.56.78"
                    },
                    {
                      name: "Harmon",
                      firstname: "Dorothée",
                      age: 36,
                      job: "Designer"
                    },
                    {
                      name: "Ritthe",
                      firstname: "Pierre",
                      age: 36,
                      job: "Testeur"
                    }
                  ],
                  size: "medium",
                  loading: false,
                  actions: [
                    {
                      label: "action_1",
                      name: "action-one",
                      callback: _vm.handleClick,
                      disabled: false
                    },
                    {
                      label: "action_2",
                      name: "action-two",
                      callback: _vm.handleClick,
                      disabled: false
                    },
                    {
                      label: "action_3",
                      name: "action-three",
                      callback: _vm.handleClick,
                      disabled: true
                    }
                  ],
                  "fix-action": "",
                  "fix-header-row": "",
                  "fix-selectable-columns": "",
                  "fix-expandable-columns": "",
                  "large-rows": "",
                  expandable: "",
                  selectable: ""
                },
                on: { selectionChange: _vm.handleTableSelectionChange }
              },
              [
                _c("template", { slot: "footer" }, [
                  _c("span", [
                    _vm._v(
                      "Si tu supprimes ce texte du slot footer, je disparais"
                    )
                  ])
                ])
              ],
              2
            ),
            _vm._v(" "),
            _c("CompassTable", {
              staticStyle: { width: "100%" },
              attrs: {
                columns: [
                  { name: "firstname", label: "Prénom" },
                  { name: "name", label: "Nom" }
                ],
                rows: [
                  { name: "Wermont", firstname: "Kévin" },
                  { name: "Cohett", firstname: "Marie" },
                  { name: "Marais", firstname: "Ludwing" },
                  {
                    name: "Mgondu",
                    firstname: "Aki",
                    subrow: {
                      component: "CompassTable",
                      props: {
                        expandable: true,
                        columns: [
                          { name: "firstname", label: "Prénom" },
                          { name: "name", label: "Nom" }
                        ],
                        rows: [
                          { name: "Wermont", firstname: "Kévin" },
                          { name: "Cohett", firstname: "Marie" },
                          { name: "Marais", firstname: "Ludwing" },
                          {
                            name: "Mgondu",
                            firstname: "Aki"
                          }
                        ]
                      }
                    }
                  }
                ],
                loading: false,
                expandable: ""
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "align-self-start typographies-heading-h1" }, [
          _vm._v("CompassTabs :")
        ]),
        _vm._v(" "),
        _c(
          "CompassTabs",
          {
            model: {
              value: _vm.tabModel,
              callback: function($$v) {
                _vm.tabModel = $$v
              },
              expression: "tabModel"
            }
          },
          [
            _c(
              "CompassTabPane",
              { attrs: { label: "Un", name: "one", icon: "pin-fill" } },
              [_vm._v("Une Belle histoire")]
            ),
            _vm._v(" "),
            _c("CompassTabPane", { attrs: { label: "Deux", name: "two" } }, [
              _vm._v("commence toujours par")
            ]),
            _vm._v(" "),
            _c("CompassTabPane", { attrs: { label: "Trois", name: "three" } }, [
              _vm._v("un développeur")
            ]),
            _vm._v(" "),
            _c(
              "CompassTabPane",
              { attrs: { label: "Quatre", name: "four", badge: 4 } },
              [_vm._v("et son chien")]
            ),
            _vm._v(" "),
            _c(
              "CompassTabPane",
              { attrs: { label: "Cinq", name: "five", badge: 0 } },
              [_vm._v("Fin")]
            ),
            _vm._v(" "),
            _c(
              "CompassTabPane",
              {
                attrs: {
                  label: "Six",
                  name: "six",
                  badge: 3,
                  flag: { label: "beta", beta: true }
                }
              },
              [_vm._v("Vraie fin")]
            ),
            _vm._v(" "),
            _c(
              "CompassTabPane",
              {
                attrs: {
                  label: "Secret",
                  name: "secret",
                  disabled: true,
                  icon: "heart"
                }
              },
              [_vm._v("Plus qu'une étape avant de kiffer: suG-c_i2fBQ")]
            )
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "align-self-start typographies-heading-h1" }, [
          _vm._v("CompassTag :")
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "container flex-col" },
          [
            _c(
              "CompassTag",
              {
                attrs: {
                  size: "small",
                  showDot: true,
                  type: "colored",
                  color: "blue",
                  showClose: true
                }
              },
              [_vm._v("\n                Coucou\n            ")]
            ),
            _vm._v(" "),
            _c(
              "CompassTag",
              { attrs: { showDot: true, color: "red", showClose: true } },
              [_vm._v("Coucou")]
            ),
            _vm._v(" "),
            _c(
              "CompassTag",
              {
                attrs: {
                  size: "large",
                  showDot: true,
                  color: "yellow",
                  showClose: true
                }
              },
              [_vm._v("Coucou")]
            )
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "align-self-start typographies-heading-h1" }, [
          _vm._v("CompassTelInput :")
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "container flex-col" },
          [
            _c("CompassTelInput", {
              attrs: { countries: ["fr", "es", "de", "us", "it"] },
              model: {
                value: _vm.phone,
                callback: function($$v) {
                  _vm.phone = $$v
                },
                expression: "phone"
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "tw-align-self-start typographies-heading-h1" },
          [_vm._v("CompassToast :")]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "container" }, [_c("CompassToastHandler")], 1),
        _vm._v(" "),
        _c("CompassButton", {
          attrs: { label: "Push NEUTRAL Toast (icon + action + close)" },
          on: {
            click: function($event) {
              return _vm.$pushToast({
                type: "neutral",
                icon: true,
                text: "Hey Salut !",
                action: {
                  text: "Informations",
                  callback: _vm.toastAction
                },
                close: true,
                timeout: 5000
              })
            }
          }
        }),
        _vm._v(" "),
        _c("CompassButton", {
          attrs: { label: "Push INFORMATIVE Toast (icon)" },
          on: {
            click: function($event) {
              return _vm.$pushToast({
                type: "informative",
                icon: true,
                text: "Adiou toi !",
                close: false,
                timeout: 5000
              })
            }
          }
        }),
        _vm._v(" "),
        _c("CompassButton", {
          attrs: { label: "Push SUCCESS Toast (icon + text)" },
          on: {
            click: function($event) {
              return _vm.$pushToast({
                type: "success",
                icon: true,
                text: "Hey, coucou",
                close: false,
                timeout: 5000
              })
            }
          }
        }),
        _vm._v(" "),
        _c("CompassButton", {
          attrs: { label: "Push WARNING Toast (text)" },
          on: {
            click: function($event) {
              return _vm.$pushToast({
                type: "warning",
                icon: false,
                text: "Oula, attention !",
                close: false,
                timeout: 5000
              })
            }
          }
        }),
        _vm._v(" "),
        _c("CompassButton", {
          attrs: { label: "Push ERROR Toast (icon, text, action; unique)" },
          on: {
            click: function($event) {
              return _vm.$pushToast({
                type: "error",
                icon: true,
                text: "Aïe, problème !",
                action: {
                  text: "Informations",
                  callback: _vm.toastAction
                },
                close: false,
                timeout: 5000,
                unique: true
              })
            }
          }
        }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "tw-align-self-start typographies-heading-h1" },
          [_vm._v("CompassTooltip :")]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "container" },
          [
            _c(
              "CompassTooltip",
              {
                attrs: {
                  content: "Top center",
                  placement: "top",
                  delay: { show: 3000, hide: 2000 }
                }
              },
              [_c("span", [_vm._v("J'ai un tooltip")])]
            ),
            _vm._v(" "),
            _c(
              "CompassTooltip",
              { attrs: { content: "Bottom start", placement: "bottom-start" } },
              [_c("span", [_vm._v("J'ai un tooltip qui pose souci")])]
            ),
            _vm._v(" "),
            _c(
              "CompassTooltip",
              { attrs: { content: "", theme: "light" } },
              [
                _c("template", { slot: "content" }, [
                  _c("span", [
                    _vm._v("Voici mon super contenu"),
                    _c("br"),
                    _vm._v("sur 2 lignes")
                  ])
                ]),
                _vm._v("\n                J'ai un super tooltip blanc"),
                _c("br")
              ],
              2
            ),
            _vm._v(" "),
            _c(
              "CompassTooltip",
              { attrs: { content: "", arrow: false } },
              [
                _c("template", { slot: "content" }, [
                  _c("span", [_vm._v("Le contenu avec tooltip")])
                ]),
                _vm._v(
                  "\n                Je n'ai pas de flèche sur mon tooltip\n            "
                )
              ],
              2
            ),
            _vm._v(" "),
            _c(
              "CompassTooltip",
              {
                attrs: {
                  content: "",
                  placement: "bottom-start",
                  arrow: false,
                  disabled: ""
                }
              },
              [
                _c("template", { slot: "content" }, [
                  _c("span", [_vm._v("Le contenu avec tooltip")])
                ]),
                _vm._v(
                  "\n                Mon tooltip n'est pas visible\n            "
                )
              ],
              2
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }